import { Stack, Typography } from '@mui/material';
import {
  sourcingExternalStepComponents,
  useSourcingExternalStore
} from 'modules/sourcing-external/stores';
import { useEffect } from 'react';
import { useGetCandidateBatchQuery } from 'generated-graphql/hooks/apollo-hooks';
import { LoadingIndicator } from 'common/ui/LoadingIndicator';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';

export const AnalyseSourcingExternal: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { candidateBatchId } =
    getPathParams.ANALYSE_SOURCE_EXTERNAL_CANDIDATES();

  const organizationConfig = useOrganizationConfig();
  const candidateBatch = useSourcingExternalStore(
    (state) => state.candidateBatch
  );
  const onInit = useSourcingExternalStore((state) => state.onInit);
  const step = useSourcingExternalStore((state) => state.step);
  const { data: candidateBatchData } = useGetCandidateBatchQuery({
    variables: {
      id: candidateBatchId
    },
    skip: !candidateBatchId
  });

  useEffect(() => {
    if (
      candidateBatch?.id !== candidateBatchId &&
      candidateBatchData?.getCandidateBatch
    ) {
      onInit(candidateBatchData.getCandidateBatch);
    }
  }, [candidateBatchId, candidateBatch, candidateBatchData]);

  if (!organizationConfig?.sourcingEnabled) {
    return (
      <Stack alignItems="center" justifyContent="center" height="100%">
        <Typography variant="heading">
          Sourcing is not enabled for this organization
        </Typography>
        <Typography variant="default">
          Please contact your administrator to enable sourcing.
        </Typography>
      </Stack>
    );
  }

  if (!candidateBatch || candidateBatchId !== candidateBatch.id) {
    return <LoadingIndicator />;
  }

  const Content = sourcingExternalStepComponents[step];

  return (
    <Stack>
      <Content />
    </Stack>
  );
};
